<template>
    <div>
        <div class="leaderBox" v-if="showOrhide1">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt1">
            <img src="../../../assets/images/xqgl1.png" class="steps step4" v-if="status1==1">
            <img src="../../../assets/images/xqgl2.png" class="steps step5" v-if="status1==2">
            <img src="../../../assets/images/xqgl3.png" class="steps step6" v-if="status1==3">
            <img src="../../../assets/images/xqgl4.png" class="steps step7" v-if="status1==4">
            <div class="stepbtn" @click="nextStep1(status1)">
                {{status1==1?"下一步":status1==2?"下一步":status1==3?"下一步":status1==4?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked1">下次不再提示</el-checkbox>
            </div>
        </div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求管理'},{title:'需求列表'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="客户名称">
							    <el-input v-model="q.euNameLike" placeholder="请输入客户名称"></el-input>
							</el-form-item>
							<el-form-item label="需求类型">
							    <brselect category="xuqiu_type" :v="q.demandType" v-model="q.demandType" :clearable="true"
							              style="width:100%;"/>
							</el-form-item>
							<el-form-item label="创建时间" class="timeselect" style="width: 50%;">
								<el-date-picker
									placeholder="请选择"
									v-model="q.startCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									placeholder="请选择"
									v-model="q.endCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
						</div>

                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
							<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
								   v-auth="'xuqiu_xinzengxuqiu'"
								   @click="createdemand">新增需求
							</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width: 57%;">
                    <div style="height: 8.9rem;overflow: hidden;background-color: white;position: relative;">
                        <div class="h-rowBox" style="border-bottom: none;box-shadow: none;">
                            <div class="h-rowTitle h-pdl0">
                                <div class="h-el-tab">
                                    <ul>
                                        <li :class="{'h-active':index==indx}" v-for="(item,index) in list" :key="index"
                                            @click="tabIndex(index)"><a>{{item}}</a></li>
                                    </ul>
                                </div>
                            </div>
                            <!--左侧列表-->
                            <el-checkbox-group v-model="checkedCities" class="h-todoCheckOut selectcheckbox"
                                               @change="handleCheckedCitiesChange">
                                <div class="selectbbbb" v-for="(item,index) in tableData" :key="item.id">
                                    <el-checkbox :label="index+1">

                                    </el-checkbox>
                                    <div class="h-todoCheck" @click="checkDetail(item)" style="cursor:pointer;padding: 0.15rem 0;">
                                        <div style="display:flex;align-items:center;width:80%">
                                            <el-tag v-if="item.demandType==1" class="ljj_tags h-label h-greenLabel">采购</el-tag>
                                            <el-tag v-else-if="item.demandType==2" class="ljj_tags h-label h-blueLabel">信息
                                            </el-tag>
                                            <el-tag v-else-if="item.demandType==3" class="ljj_tags h-label h-orangeLabel">资源
                                            </el-tag>
                                            <a class="h-ellipsis">{{item.euName}}</a>
                                            <span class="h-todoLabel"
                                                  v-if="item.euType!=0">{{item.contactuserName}}</span>
                                            <span class="h-todoLabel" v-else-if="item.euType==0">{{item.cuname}}</span>
                                            <span class="h-todoTime"> {{item.cdate?item.cdate.substr(0,10):''}}</span>
                                        </div>
                                        <span class="cuname" style="float:right"
                                              v-show="cunamelist">{{item.cuname}}</span>
                                        <el-tag v-if="item.isproject==1 && item.demandType!=3 && item.isrefer==1"
                                                class="ljj_tags h-label2 h-greenLabel h-fr">已转化
                                        </el-tag>
                                        <el-tag v-else-if="item.isproject==0 && item.demandType!=3 && item.isrefer==1"
                                                class="ljj_tags h-label2 h-blueLabel h-fr">未转化
                                        </el-tag>
                                        <el-tag v-else-if="item.isproject==1 && item.demandType==3 && item.isrefer==1"
                                                class="ljj_tags h-label2 h-greenLabel h-fr">已闭环
                                        </el-tag>
                                        <el-tag v-else-if="item.isproject==0 && item.demandType==3 && item.isrefer==1"
                                                class="ljj_tags h-label2 h-blueLabel h-fr">未闭环
                                        </el-tag>
                                        <el-tag v-else-if="item.isproject==0 && item.isrefer==0"
                                                class="ljj_tags h-label2 h-orangeLabel h-fr">草稿
                                        </el-tag>
                                    </div>
                                </div>
                            </el-checkbox-group>
                            <div class="fenyes">
                                <paginationmin :page="q" @query="query" style="padding-top: 0.3rem"/>
                            </div>
                            <div v-if="tableData.length<5"
                                 style="display:flex;justify-content:center;padding-top: 30px;align-items: center;">
                                <img src="../../../assets/images/mylittle.png" alt="" style="width: 75%;">
                            </div>
                            <div class="h-rowBoxB h-rowBoxBtnOut"
                                 style="margin: 0;padding: 0.11rem 0.26rem;display: flex;align-items: center;height: 67px;position: absolute;bottom: 0;left: 0;width: 100%;border: 1px solid #d7e0f1;">
                                <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                <!-- <el-button class="h-btn h-formBtn h-bgblueQ2" @click="deletechecked()">删除所选</el-button>-->
                                <!-- <el-button class="h-btn h-formBtn h-bgwhite2" @click="tabIndex(index)">返回</el-button>-->
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                           @click="exportExcel" v-auth="'xuqiu_piliangdaochu'">批量导出
                                </el-button>
                                <!--<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                           @click="caiuploaddownexcelflagbtn" v-auth="'xuqiu_caigoudaoru'">采购需求导入
                                </el-button>
                                <uploaddownexcel :visible.sync="caiuploaddownexcelflag" v-if="caiuploaddownexcelflag"
                                                 clsname="caiImportExcel"
                                                 :startrow="3" @callback="uploadExcelFilecallback"/>
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                           @click="uploaddownexcelflagbtn" v-auth="'xuqiu_xinxidaoru'">信息获取导入
                                </el-button>
                                <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                                 clsname="xuqiuImportExcel"
                                                 :startrow="3" @callback="uploadExcelFilecallback"/>
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                           @click="ziuploaddownexcelflagbtn" v-auth="'xuqiu_ziyuandaoru'">资源需求导入
                                </el-button>
                                <uploaddownexcel :visible.sync="ziuploaddownexcelflag" v-if="ziuploaddownexcelflag"
                                                 clsname="demandImportExcel"
                                                 :startrow="3" @callback="uploadExcelFilecallback"/>-->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-rowIn" style="width: 43%;">
                    <div style="height: 8.9rem;overflow-y: auto;background-color: white;padding: 0;position: relative;">
                        <div class="h-rowBox">
                            <div class="h-rowTitle" v-show="ifchart">
                                <div class="h-disTable">
                                    <div class="h-tableCell">
                                        <h1>需求统计</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="h-rowCon">
                                <div v-show="ifchart">
                                    <div class="h-gaugePieChart" id="h_gaugePie"
                                         style="width:100%;height:4rem;"></div>

                                    <div class="totals" v-if="this.indx ==0">全部 {{chartPer.all}}</div>
                                    <div class="totals" v-if="this.indx ==1">已完成 {{chartPer.done}}</div>
                                    <div class="totals" v-if="this.indx ==2">未完成 {{chartPer.todo}}</div>
                                    <!--右侧图表下数据展示-->
                                    <div class="h-gaugePieLegend">
                                        <div class="h-gpLegendLi">
                                            <i class="h-greenBgLegend"></i>

                                            <p style="display: inline;">已完成</p>
                                        </div>
                                        <div class="h-gpLegendLi">
                                            <i class="h-blueBgLegend"></i>

                                            <p style="display: inline;">未完成</p>
                                        </div>
                                    </div>
                                </div>
                                <!--右下侧详情展示-->
                                <div class="h-runningDetail" v-show=detailShow>
                                    <div class="h-rdTitle">
                                        <h1 style="font-weight: normal;margin-bottom:10px;">需求详情</h1>
                                    </div>
                                    <div class="h-rdTitle">
                                        <h1>{{qdetail.euName}}</h1>
                                        <label v-if="qdetail.isproject==1 && qdetail.isrefer==1">已转化</label>
                                        <label v-if="qdetail.isproject==0 && qdetail.isrefer==1">未转化</label>
                                        <label v-if="qdetail.isproject==0 && qdetail.isrefer==0">草稿</label>
                                    </div>
                                    <div class="h-rdForm" style="overflow-y: auto;height: 6rem;">
										<div class="h-rdFormWrap" style="width:100%;text-align: left;height: auto">
										    <p class="h-grayFont">需求背景及说明</p>
										    <p>{{qdetail.content?qdetail.content:''}}</p>
										</div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">需求来源</p>
                                            <p v-if="qdetail.euType!=0">{{qdetail.euType}}</p>
                                            <p v-if="qdetail.euType==0">内部需求</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.euType!=0">
                                            <p class="h-grayFont">区域</p>
                                            <p>{{qdetail.customer?qdetail.customer.areaCode:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.euType!=0">
                                            <p class="h-grayFont">渠道</p>
                                            <p>{{qdetail.customer?qdetail.customer.channelCode:"" |
                                                dictname("sales_region")}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.euType!=0">
                                            <p class="h-grayFont">部门/科室</p>
                                            <p>{{qdetail.department}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.euType!=0">
                                            <p class="h-grayFont">联系人</p>
                                            <p>{{qdetail.contactuserName}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.euType!=0">
                                            <p class="h-grayFont">联系方式</p>
                                            <p>{{qdetail.telephone}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">需求类型</p>
                                            <p v-if="qdetail.demandType==1">采购需求</p>
                                            <p v-else-if="qdetail.demandType==2">信息获取</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont" v-if="qdetail.demandType==2">产品大类</p>
                                            <p v-if="qdetail.demandType==2">
                                                {{qdetail.detail?qdetail.detail.codeName:""}}</p>
                                            <p class="h-grayFont" v-if="qdetail.demandType==1">采购类别</p>
                                            <p v-if="qdetail.demandType==1">{{qdetail.cgType}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont"
                                               v-if="qdetail.demandType==1 && qdetail.cgType=='标准采购'">标准采购</p>
                                            <p v-if="qdetail.demandType==1&&qdetail.cgType=='标准采购'">
                                                {{qdetail.cgStandard}}</p>
                                            <p class="h-grayFont"
                                               v-if="qdetail.demandType==1 && qdetail.cgType=='定向招投'">供应商</p>
                                            <p v-if="qdetail.demandType==1 && qdetail.cgType=='定向招投'">
                                                {{qdetail.suppliername}}</p>
                                            <p class="h-grayFont" v-if="qdetail.demandType==2">产品型号</p>
                                            <p v-if="qdetail.demandType==2">
                                                {{qdetail.detail?qdetail.detail.proName:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.isproject==1">
                                            <p class="h-grayFont">项目编码</p>
                                            <p>{{qdetail.projectId}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.isproject==1">
                                            <p class="h-grayFont">项目名称</p>
                                            <p>{{qdetail.projectName}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.demandType==2">
                                            <p class="h-grayFont" v-if="qdetail.demandType==2">数量</p>
                                            <p v-if="qdetail.demandType==2">
                                                {{qdetail.detail?qdetail.detail.proNumber:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.demandType==2">
                                            <p class="h-grayFont" v-if="qdetail.demandType==2">单价</p>
                                            <p v-if="qdetail.demandType==2">
                                                {{qdetail.detail?qdetail.detail.proPrice:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" v-if="qdetail.demandType==2">
                                            <p class="h-grayFont" v-if="qdetail.demandType==2">总价</p>
                                            <p v-if="qdetail.demandType==2">
                                                {{qdetail.detail?qdetail.detail.proTotalAmount:''}}</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="h-rowBoxB h-rowBoxBtnOut" v-show="detailShow"
                                 style="position: absolute;bottom: 0;left: 0;width: 100%;margin: 0;padding: 0.11rem 0.16rem;height: 67px;border: 1px solid #d7e0f1;">
                                <el-button class="el-button h-btn h-formBtn h-bgblueQ el-button--default"
                                           v-if="qdetail.isrefer==1 && qdetail.isproject==0 && qdetail.cucode == _user.usercode"
                                           @click="transforxm(qdetail)">一键转化项目
                                </el-button>
                                <el-button class="el-button h-btn h-formBtn h-bgblueQ el-button--default" v-else
                                           style="background-color: #d4d4d4;border-color: #d4d4d4;">一键转化项目
                                </el-button>
                                <el-button class="el-button h-btn h-formBtn h-bgblueQ el-button--default"
                                           v-if="qdetail.isrefer==0"
                                           @click="xuqiuEdit(qdetail)">编辑
                                </el-button>
                                <el-button class="el-button h-btn h-formBtn h-bgblueQ el-button--default"
                                           v-else-if="qdetail.isrefer==1 || qdetail.isrefer==2"
                                           @click="xuqiuDetail(qdetail)">详情
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <demandadd :visible.sync="imgflag2" v-if="imgflag2" @imgfalse2="imgflag2=false"/>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                userCode:'',
                showOrhide1: false,
                status1: 1,
                checked1: true,
                toshow1: "Lmanagement3",
                imgflag2: false,

                //caifile:false,
                //xuqiu:false,
                //ziyuan:false,
                cunamelist: false,
                //当前登陆人的权限列表
                rolelist: [],
                //导入Excel
                uploaddownexcelflag: false,
                caiuploaddownexcelflag: false,
                ziuploaddownexcelflag: false,
                timeValue: null,
                shoor: false,
                //全选
                checkedCities: [],
                cities: this.cityOptions,
                cityOptions: [],
                checkAll: false,
                multipleSelection: [],
                detailShow: false,
                xuqiuList: ['资源需求', '信息获取', '采购需求'],
                xuqiudex: 0,
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                formLabelAlign2: {},
                val: [],
                n: {},
                //切换
                indx: 0,
                list: ['全部', '已完成', '未完成'],
                q: {
                    startCdate: null,
                    endCdate: null,
                    isrefer: null,
                    euName: null,
                    demandType: null,
                    depCode: null,
                    cuname: null,
                    content: null,
                    isproject: null,
                    indexs: null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tablelist: [],
                tableName: {},
                tableData: [],
                LevelName: [],
                qdetail: {
                    id: null,
                    demandType: null,
                    customer: {
                        areaCode: null,
                        channelCode: null,
                    }
                },
                //表单
                f: {
                    demandType: null,
                    rdId: null,
                    userCode: null,
                    resDescribe: null,
                    content: null,
                    cid: null,
                    remark: null,
                    cucode: null,
                    cuname: null,
                    cdate: null,
                    lucode: null,
                    ldate: null,
                    delflag: null,
                    endDate: null,
                    euCode: null,
                    euName: null,
                    detail: [
                        {
                            depName: null,
                        }
                    ],
                    customer: [],
                },
                //弹出框
                dialogFormVisible: false,
                chartPer: {
                    all: 0,
                    done: 0,
                    todo: 0,
                },
                options: {},
                ifchart: true,
                CGList: [],
                DDList: [],
                ZYList: [],
            }
        },
        methods: {
            showzhezhao() {
                ss.salesList.toshow(this.toshow1).then(rd => {
                    console.log(rd)
                    if (rd == false) {
                        this.showOrhide1 = false;
                    } else {
                        this.showOrhide1 = true;
                    }
                })
            },
            //导入Excel
            caiuploaddownexcelflagbtn() {
                this.caiuploaddownexcelflag = true;
            },
            //导入Excel
            ziuploaddownexcelflagbtn() {
                this.ziuploaddownexcelflag = true;
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            timeSelect() {
                if (this.timeValue == null || this.timeValue == '') {
                    this.q.startCdate = null;
                    this.q.endCdate = null;
                } else {
                    this.q.startCdate = this.timeValue[0];
                    this.q.endCdate = this.timeValue[1];
                }
            },
            daoru() {
                this.dialogFormVisible2 = true;
            },
            //重置检索项
            resetData() {
                this.q.euNameLike = null;
                this.q.demandType = null;
                this.timeValue = null;
                this.q.startCdate = null;
                this.q.endCdate = null;
                this.q.depCode = null;
            },
            //检索
            handleFilter(query) {
                this.query();
                this.chartP();
            },
            //全部/已转化/为转化标签
            tabIndex(i) {
                this.indx = i;
                if (this.indx == 0) {
                    this.q.isproject = null;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.done ? this.chartPer.done : 0,
                            name: '已完成'
                        },
                        {
                            value: this.chartPer.todo ? this.chartPer.todo : 0,
                            name: '未完成',

                        },
                    ];
                } else if (this.indx == 1) {
                    this.q.isproject = 1;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.done ? this.chartPer.done : 0,
                            name: '已完成',
                            selected: true
                        },
                        {
                            value: this.chartPer.todo ? this.chartPer.todo : 0,
                            name: '未完成',


                        },
                    ];
                } else if (this.indx == 2) {
                    this.q.isproject = 0;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.done ? this.chartPer.done : 0,
                            name: '已完成'
                        },
                        {
                            value: this.chartPer.todo ? this.chartPer.todo : 0,
                            name: '未完成',
                            selected: true

                        },
                    ];
                }
                this.getPieChartnow();
                this.ifchart = true;
                this.detailShow = false;
                console.log(this.ifchart)
            },
            //表格
            query() {
                if (this.sh) {
                    this.q.shanghai = 1;
                } else {
                    this.q.shanghai = 0;
                }
                if (this.q.demandType != 3) {
                    this.q.depCode = null;
                }
                ss.UserDemand.selectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.cityOptions = [];
                    for (let i = 0; i < 10; i++) {
                        this.cityOptions.push(i + 1);
                    }
                })
            },
            //产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            //右侧图表数据展示
            chartP() {
                if (this.sh) {
                    this.q.shanghai = 1;
                } else {
                    this.q.shanghai = 0;
                }
                ss.UserDemand.demandChart(this.q).then(rd => {
                    this.chartPer.all = rd.chartNum.chartAll;
                    this.chartPer.done = rd.chartNum.chartDone;
                    this.chartPer.todo = rd.chartNum.chartTodo;
                    this.getPieChart();
                })
            },
            getPieChartnow() {
                let h_gaugePie = this.$echarts.init(document.getElementById('h_gaugePie'));
                let placeHolderStyle = {
                    normal: {
                        color: 'rgba(0,0,0,0)',
                        label: {show: false},
                        labelLine: {show: false}
                    },
                    emphasis: {
                        color: 'rgba(0,0,0,0)'
                    }
                };

                h_gaugePie.setOption(this.options);
            },
            getPieChart() {
                let h_gaugePie = this.$echarts.init(document.getElementById('h_gaugePie'));
                let placeHolderStyle = {
                    normal: {
                        color: 'rgba(0,0,0,0)',
                        label: {show: false},
                        labelLine: {show: false}
                    },
                    emphasis: {
                        color: 'rgba(0,0,0,0)'
                    }
                };
                let option = {
                    tooltip: {
                        show: true,
                    },
                    legend: {
                        show: false
                    },
                    grid: {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0
                    },
                    color: ['#2eaf68', '#258efe', '#f2bd2e'],
                    series: {

                        type: 'pie',

                        radius: "70%",
                        center: ['50%', '50%'],
                        labelLine: {
                            show: true,
                            length: 10,
                        },
                        label: {
                            show: true,
                            formatter: '{b}{c}',
                        },
                        data: [
                            {
                                value: this.chartPer.done ? this.chartPer.done : 0,
                                name: '已完成'
                            },
                            {
                                value: this.chartPer.todo ? this.chartPer.todo : 0,
                                name: '未完成',

                            },

                        ]
                    }
                }
                h_gaugePie.setOption(option);
            },
            //右下侧详细数据展示
            checkDetail(value) {
                this.detailShow = true;
                this.ifchart = false;
                if (value.demandType == 1) {
                    ss.UserDemand.demandDetail1(value.id).then(rd => {
                        this.qdetail = rd;
                        if (this.qdetail.euType != 0) {
                            this.qdetail.euType = this.$getDictName("userCareType", rd.euType);
                            this.qdetail.customer.areaCode = this.$getDictName("YLRegion", rd.customer.areaCode);
                            this.qdetail.customer.channelCode = this.$getDictName("sales_region", rd.customer.channelCode);
                        }
                    });
                } else if (value.demandType == 2) {
                    ss.UserDemand.demandDetail2(value.id).then(rd => {
                        this.qdetail = rd;
                        this.qdetail.euType = this.$getDictName("userCareType", rd.euType);
                        this.qdetail.customer.areaCode = this.$getDictName("YLRegion", rd.customer.areaCode);
                        this.qdetail.customer.channelCode = this.$getDictName("sales_region", rd.customer.channelCode);
                    });
                }
            },
            //新增需求
            createdemand() {
                if (this.$store.getters.hasRole("swyl_xiaoshoujl,swyl_admin,swyl_guanhgly")) {
                    // this.dialogFormVisible1 = true;
                    this.imgflag2 = true;
                } else if (this.$store.getters.hasRole("caigoujingli")) {
                    this.$router.push('/xuqiu/purchase')
                } else if (this.$store.getters.hasRole("shzxcaigoujingli,swyl_shanghailq_xiaoweizhu,swyl_shanghai_caiwu,swyl_xiaoshoujl_shanghai")) {
                    this.$router.push('/xuqiu/purchasesh')
                }
            },
            xuqiuEdit(value) {
                if (value.demandType == 1) {
                    this.$router.push({path: "/xuqiu/purchase", query: {id: value.id}});
                } else if (value.demandType == 2) {
                    this.$router.push({
                        path: "/xuqiu/xuqiuDetail", query: {id: value.id, demandType: value.demandType}
                    });
                }

            },
            //点击详情跳转
            xuqiuDetail(value) {
                if (value.demandType == 1) {
                    this.$router.push({path: "/xuqiu/purchaseDetail", query: {id: value.id}});
                } else if (value.demandType == 2 && value.isproject == 0) {
                    if (value.cucode == this.userCode) {
                        this.$router.push({
                            path: "/xuqiu/xuqiuDetail", query: {id: value.id, demandType: value.demandType}
                        });
                    } else {
                        this.$router.push({
                            path: "/xuqiu/xuqiuDetailReadonly", query: {id: value.id, demandType: value.demandType}
                        });
                    }
                } else if (value.demandType == 2 && value.isproject == 1) {
                    this.$router.push({
                        path: "/xuqiu/xuqiuDetailReadonly", query: {id: value.id, demandType: value.demandType}
                    });
                }
            },
            handleCheckAllChange(val) {
                this.checkedCities = val ? this.cityOptions : [];
            },
            handleCheckedCitiesChange(value) {
                this.multipleSelection = value;
                console.log(this.multipleSelection, "勾选时的值");
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.cityOptions.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cityOptions.length;
            },
            //删除ids
            deletechecked() {
                this.$msg.confirm("确认删除?", () => {
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        this.num = this.multipleSelection[i];
                        this.n = this.tableData[this.num];
                        this.en.push(this.n);
                    }
                })
            },
            //转化为项目
            transforxm(value) {
                this.$router.push({
                    path: "/xiangmu/newProject", query: {id: value.id, demandType: value.demandType}
                });
            },
            //明细导出
            exportExcel() {
                var CGList = [];
                var DDList = [];
                var idList = [];
                this.multipleSelection.forEach((item, index) => {
                    this.n = this.tableData[item - 1];
                    idList.push(this.n);

                });
                if (idList.length == 0) {
                    idList = this.tableData;
                    idList[0].demandType = 4;
                    CGList.push(idList[0]);
                    DDList.push(idList[0]);
                } else {
                    idList.forEach((item, index) => {
                        if (item.isrefer == 0) {
                            delete idList[index];
                        } else {
                            if (item.demandType == 1) {
                                CGList.push(item);
                            } else if (item.demandType == 2) {
                                DDList.push(item);
                            }
                        }
                    });
                }
                if (CGList.length != 0) {
                    if (this.$store.getters.hasRole("swyl_xiaoshoujl,swyl_admin,swyl_guanhgly,caigoujingli")) {
                        updownfile.down("/api/swyl/v1/xuqiu/userResProcurement/downloadExcel", CGList, "post", 'data');
                    }
                }
                if (DDList.length != 0) {
                    if (this.$store.getters.hasRole("swyl_xiaoshoujl,swyl_admin,swyl_guanhgly")) {
                        updownfile.down("/api/swyl/v1/xuqiu/userResProduct/downloadExcel", DDList, "post", 'data');
                    }
                }
                this.query();
            },
            closeIt1() {
                this.showOrhide1 = false;
                if (this.checked1) {
                    ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                        console.log(rd)
                        this.showOrhide1 = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                        console.log(rd)
                        this.showOrhide1 = false;
                    })
                }
            },

            nextStep1(i) {
                if (this.status1 == 1) {
                    this.status1 = 2;
                } else if (this.status1 == 2) {
                    this.status1 = 3;
                } else if (this.status1 == 3) {
                    this.status1 = 4;
                } else if (this.status1 == 4) {
                    if (this.checked1) {
                        ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                            console.log(rd)
                            this.showOrhide1 = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                            console.log(rd)
                            this.showOrhide1 = false;
                        })
                    }
                }

            },
        }
        ,
        created() {
            this.showzhezhao()
            this.query();
            this.chartP();
            this.showLevelName();
            this.cunamelist = this.$store.getters.hasRole("caigoujingli,swyl_admin,swyl_guanhgly,swyl_xuqiugly,swyl_shanghailq_xiaoweizhu,swyl_shanghai_caiwu,swyl_xiaoshoujl_shanghai");
            this.userCode = this._user.usercode;
        }
        ,
        mounted() {
            this.chartP();
            this.query();
            this.options = {
                tooltip: {
                    show: true,
                },
                legend: {
                    show: false
                },
                grid: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                },
                color: ['#2eaf68', '#258efe', '#f2bd2e'],
                series: {

                    type: 'pie',

                    selectedOffset: 10,
                    radius: "70%",
                    center: ['50%', '50%'],
                    labelLine: {
                        show: true,
                        length: 10,
                    },
                    label: {
                        show: true,
                        formatter: '{b}{c}',
                    },
                    data: []
                }
            }

        }
        ,
    }
</script>

<style scoped>
    .cuname {
        font-size: 0.16rem;
        color: #323232;
    }

    .selectbbbb {
        display: flex;
        align-items: center;
        border-bottom: 2px solid #f9f9f9;
    }

    .selectbbbb:hover {
        background: #f5fcff;
    }

    .h-gaugePieLegend .h-gpLegendLi i {
        margin-top: -12px;
    }

    .totals {
        text-align: center;
        font-size: 0.22rem;
        color: #282828;
        margin-bottom: 20px;
    }


    .h-formLines {
        padding: 30px 48px;
    }

    .xuqiuBoxList {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }

    .xuqiuBoxList .xuqiulist {
        width: 200px;
        height: 62px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #959595;
        text-align: center;
        line-height: 62px;
        color: #989898;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
    }

    .xuqiuBoxList .xuqiulist:first-child {
        margin-left: 0
    }

    .xuqiuBoxList .xuqiulist.active {
        background: #238cfd;
        border: 1px solid #238cfd;
        color: #fff;
    }

    .xuqiutext {
        color: #bcbcbc;
        font-size: 14px;
        margin-bottom: 14px;
    }

    /* .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }

    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    } */

    /* .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;
        margin-left: 10px;
    }

    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 20px;
    }

    .piliangBox .imgs:first-child {
        margin-left: 0
    } */
</style>
<style>
    .selectcheckbox .el-checkbox:hover {
        background: 0
    }

    .selectcheckbox .el-checkbox {
        margin-bottom: 5px
    }

    .selectcheckbox .el-checkbox__label {
        display: none
    }

    .h-dialogForm .h-elformWrap-3 .el-form-item__label:first-child {
        width: 23%;
    }

    .h-dialogForm .h-elformWrap-3 .el-form-item__content {
        width: 70%;
    }

    .el-form-item__content .secondX {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }

    .fenyes .el-pagination .el-pagination__sizes {
        display: none;
    }

 /*   .h-formBorder .timeselect .el-form-item__content {
        line-height: 0.2rem;
    } */

    .h-formBorder .timeselect .el-date-editor .el-range-separator {
        width: 8%;
        line-height: 28px;
    }

    .h-formBorder .timeselect .el-input__inner {
        padding-right: 0.1rem;
    }

    .timeselect .el-date-editor.el-input__inner {
        width: 3.5rem;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step4 {
            top: 0.8rem;
            left: 0rem;
            width: 6.6rem;
            height: 15rem;
        }

        .step5 {
            top: 2.2rem;
            right: 1.35rem;
            width: 4.7rem;
            height: 1rem;
        }

        .step6 {
            top: 2.28rem;
            left: 2.6rem;
            width: 9.2rem;
            height: 12rem;
        }

        .step7 {
            top: 3.45rem;
            right: 0.2rem;
            width: 6.9rem;
            height: 12rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
